<template>
    <swiper-slide class="flex h-full w-full justify-center">
        <slot></slot>
    </swiper-slide>
</template>
